// This initialization script was provided by Mather
import Cookies from "js-cookie";

function initListener({cid, mkt, config, domain, cacheBusterVersion = ""}) {
    var ml = document.createElement('script');
    var s = document.getElementsByTagName('script')[0] || document.head;
    var cb;
    try {
        if (!(cb = localStorage._matherVer)) {
            throw false;
        }
    } catch (e) {
        cb = Math.round(new Date() / 1.0368e9);
    }
    ml.type = 'text/javascript';
    ml.async = true;
    ml.defer = true;
    ml.id = '_mljs';
    ml.src = ('https:' == window.location.protocol ? 'https' : 'http') + '://' + (domain || 'js.matheranalytics.com/s') + '/' + cid + '/' + mkt
        + '/' + (config ? config + '/' : '') + 'ml.js?cb' + cacheBusterVersion + '=' + cb;
    s.parentNode.insertBefore(ml, s);
}

/**
 * Allows easier debugging of mather events.
 *
 * Analyzes the network requests sent to mather and parses the request querystring.
 */
function debugMatherEvents() {
    if (PerformanceObserver) {
        const observer = new PerformanceObserver((performanceEntryList) => {
            const matherEvents = performanceEntryList.getEntries().filter((event) => event.name.includes('i.matheranalytics.com'));
            for (let matherEvent of matherEvents) {
                const [, matherQueryString] = matherEvent.name.split('?');
                if (!matherQueryString) continue;
                var queryStringPairs = matherQueryString.split('&');
                var result = {};
                queryStringPairs.forEach(function (pair) {
                    pair = pair.split('=');
                    result[pair[0]] = decodeURIComponent(pair[1] || '');
                });

                const matherEventData = JSON.parse(JSON.stringify(result));

                console.group('[MATHER] Event Fired');
                if ('cx' in matherEventData) {
                    matherEventData.cx = atob(matherEventData.cx);
                    console.group('Event Data');
                    console.log(JSON.parse(matherEventData.cx));
                    console.groupEnd();
                }
                console.groupCollapsed('All Request Data Sent');
                console.table(matherEventData, ['Value']);
                console.groupEnd();
                console.groupEnd();
            }
        });
        observer.observe({entryTypes: ['resource']});
    }
}

export default function matherListener(config) {
    let tracker = null;
    // Holds the options data that can optionally be passed to mather event calls
    // Used to pass the `userId` to mather.
    let matherOptions = {};
    // Holds the latest information that we know about the user
    let userTraits = {};

    return {
        name: 'mather',
        config: config,
        initialize: ({config, instance}) => {
            if (instance.getState('context.debug') === true) {
                debugMatherEvents();
            }

            let matherConfig = {
                cid: config.customerId,
                mkt: config.marketId,
                cacheBusterVersion: '7',
            };
            initListener(matherConfig);

            (window._matherq = window._matherq || []).push(['getTracker', (_tracker) => tracker = _tracker]);
        },
        loaded: () => {
            return tracker !== null;
        },
        page: ({payload}) => {
            const matherPayload = JSON.parse(JSON.stringify(payload));
            matherPayload.properties = {
                ...matherPayload.properties,
                ...userTraits,
            };
            window._matherq.push(["nextPageView", matherPayload]);
        },
        track: ({payload}) => {
            const {event, properties} = payload;
            let {product, products} = properties;

            // Only report events that Mather has specifically requested. Ignore all others.
            switch (event) {
                case 'AdImpression':
                    if (!properties.rendered) break;
                    tracker.trackUnstructEvent('Ad Impression', {
                        eaid: properties.line_item_id,
                        ebuy: properties.campaign_id,
                        eadv: properties.advertiser_id,
                        ecid: properties.creative_id,
                        eenv: 'j',
                        epid: properties.ad_unit_path,
                        esid: null,
                        size: properties.ad_size,
                        rendered: properties.rendered ? '1' : '0'
                    });
                    break;
                case 'ViewProducts':
                    window._matherq.push(['paywallEvent', {
                        category: 'payment',
                        action: 'subscriptions_offered',
                        offers: products
                    }, matherOptions]);
                    break;
                case 'CompleteLogin':
                    if (properties.is_order_tunnel) {
                        window._matherq.push(['paywallEvent', {
                            category: 'registration',
                            action: 'logon'
                        }, matherOptions]);
                    }
                    break;
                case 'CompletePasswordResetConfirm': {
                    let finishRegistrationWallAccount = Cookies.get("FinishRegistrationWallAccount");
                    if (finishRegistrationWallAccount !== undefined) {
                        window._matherq.push(['paywallEvent', {
                            type: 'regwall',
                            category: 'registration',
                            action: 'password_created'
                        }]);
                        Cookies.remove("FinishRegistrationWallAccount");
                    }
                    break;
                }
                case 'CompleteRegister':
                    if (properties.is_order_tunnel) {
                        window._matherq.push(['paywallEvent', {
                            category: 'registration',
                            action: 'created'
                        }, matherOptions]);
                    }
                    break;
                case 'DisplayRegistrationWall':
                    window._matherq.push(['paywallEvent', {
                        type: 'regwall',
                        category: 'block',
                        action: 'stop'
                    }, matherOptions]);
                    break;
                case 'DisplaySubscribePrompt':
                    window._matherq.push(['paywallEvent', {
                        type: 'paywall',
                        category: 'block',
                        action: 'stop'
                    }, matherOptions]);
                    break;
                case 'PrintSubscriberRequest':
                    if (!Object.prototype.hasOwnProperty.call(properties, 'is_print_subscriber')) {
                        // Don't send the event if they didn't check the print subscriber checkbox
                        return;
                    }
                    if (properties.is_print_subscriber !== 'on') {
                        // Don't send the event if they didn't check the print subscriber checkbox
                        return;
                    }
                    window._matherq.push(['paywallEvent', {
                        category: 'registration',
                        action: 'activation_lookup'
                    }, matherOptions]);
                    break;
                case 'ShowOrderTunnelRegistration':
                    window._matherq.push(['paywallEvent', {
                        category: 'registration',
                        action: 'start'
                    }, matherOptions]);
                    break;
                case 'AddToCart':
                    window._matherq.push(['paywallEvent', {
                        category: 'payment',
                        action: 'subscription_selected',
                        // Mather needs this as an array even though it will always be 1 product
                        offers: [product]
                    }, matherOptions]);
                    window._matherq.push(['paywallEvent', {
                        category: 'payment',
                        action: 'address_information'
                    }, matherOptions]);
                    window._matherq.push(['paywallEvent', {
                        category: 'payment',
                        action: 'payment_information'
                    }, matherOptions]);
                    break;
                case 'AddPaymentInfo':
                    // This is actually the event that fires when the Confirm Purchase button is displayed,
                    // which comes as a result of Adding Payment Information.
                    window._matherq.push(['paywallEvent', {
                        category: 'payment',
                        action: 'payment_confirmation'
                    }, matherOptions]);
                    break;
                case 'Purchase':
                    window._matherq.push(['paywallEvent', {category: 'payment', action: 'completed'}, matherOptions]);
                    break;
                case 'SubmitRegistrationWall': {
                    matherOptions['email'] = properties['email'];
                    const submitRegistrationType = properties['method'];
                    const submitMatherEventData = {
                        type: 'regwall',
                        category: 'registration',
                        action: 'start',
                    };

                    if (submitRegistrationType.toUpperCase() !== 'DIRECT') {
                        submitMatherEventData.offers = [{offerName: submitRegistrationType}];
                    }
                    window._matherq.push(['paywallEvent', submitMatherEventData, matherOptions]);
                    break;
                }
                case 'CompleteRegistrationWall': {
                    const completeRegistrationType = properties['method'];
                    const completeMatherEventData = {
                        type: 'regwall',
                        category: 'registration',
                        action: 'created'
                    };
                    if (completeRegistrationType.toUpperCase() !== 'DIRECT') {
                        completeMatherEventData.offers = [{offerName: completeRegistrationType}];
                    }
                    window._matherq.push(['paywallEvent', completeMatherEventData, matherOptions]);
                    break;
                }
                default:
                    break;
            }
        },
        identify: ({payload}) => {
            userTraits = payload.traits;
            matherOptions.userId = payload.userId;
        },
    }
}
